"use client";
import { Dispatch, SetStateAction, useEffect, useState } from "react";

import { Anchoring } from "~/hooks/anchoring/types";
import { getItem, removeItem } from "~/hooks/use-session-storage/hook";

export const useGetAnchor = (
  page: Anchoring["page"],
): [string | null, Dispatch<SetStateAction<string | null>>] => {
  const [markerId, setMarkerId] = useState(() => {
    const persistedId = getItem(page);
    removeItem(page);
    return persistedId ? persistedId : null;
  });
  useEffect(() => {
    if ("scrollRestoration" in history) {
      history.scrollRestoration = "manual";
    }
  }, []);
  return [markerId, setMarkerId];
};
